import axios from 'axios';
import { create } from 'apisauce';
import Cookies from 'universal-cookie';
import { getAuthUrl } from 'utils/utils';

const axiosInstance = axios.create({
  baseURL: getAuthUrl() || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

const api = create({ axiosInstance });

const setAuthorizationHeaeder = () => {
  const cookies = new Cookies();
  const idtToken = cookies.get('app.idt');
  api.setHeader('Authorization', 'Bearer ' + idtToken);
};

export const changePassword = (payload) => {
  setAuthorizationHeaeder();
  return api.post('/api/user/change-password', payload);
};

export const twoFactorLogin = (payload) => {
  return api.post('/api/two-factor/login', payload);
};
